module.exports = __webpack_public_path__ + "media/images/normal-a70597e606170ffa3edc7fc598e98864.png";